import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import api from "../../utils/api";
import { userAtom } from "../../utils/store";

interface UseGetStudentUploadedDocumentsQueryProps {
  applicantId?: string;
}

const getStudentUploadedDocuments = async (applicantId: string) => {
  return (
    await api.get(`AdmissionDocument/Admin/GetStudentDocuments?applicantId=${applicantId}`)
  ).data as StudentUploadedDocumentsResponse;
};

export const useGetStudentUploadedDocumentsQuery = (
  props?: UseGetStudentUploadedDocumentsQueryProps,
) => {
  const user = useAtomValue(userAtom);
  const applicantId = props?.applicantId ?? user?.applicantId;

  const query = useQuery({
    queryKey: ["get-student-uploaded-documents", applicantId],
    queryFn: () => getStudentUploadedDocuments(applicantId as string),
    enabled: !!applicantId,
  });

  return {
    ...query,
    documents: query.data?.data as StudentUploadedDocument[] | undefined,
  };
};

export default useGetStudentUploadedDocumentsQuery;
